import { useAppSelector } from "@/app/hooks";
import { layerList } from "@/components/LayerList/layerListSlice";
import { db } from "@/lib/db";
import type { LayerLegendInfo } from "@/types";
import LegendVM from "@arcgis/core/widgets/Legend/LegendViewModel";
import { useEffect } from "react";

/** Copies each layer's legend symbols from the live legend into IndexedDB, once per layer. */
export function useLayerLegendInfos(legend: LegendVM | null, onNotice: (message: string) => void) {
    const layers = useAppSelector(layerList);

    useEffect(() => {
        if (!legend || layers.length === 0) return;
        let active = true;
        const saveLegendInfos = async () => {
            for (const layer of layers) {
                if (!active) return;
                if (layer.legendInfos?.length > 0) continue;
                const groupLegend = legend.activeLayerInfos.find((info) => info.layer.title === layer.group);
                const layerLegend = groupLegend?.children?.find((child) => child.layer.title === layer.title);
                if (!layerLegend) continue;
                const infos = layerLegend.legendElements?.[0]?.infos ?? [];
                const legendInfos: LayerLegendInfo[] = infos.map((info) => ({ title: info.label?.toString() ?? layer.title, symbol: info.symbol.toJSON() }));
                await db.layerState.update(layer.id, { legendInfos });
            }
        };
        void saveLegendInfos().catch(() => { if (active) onNotice('Layer legends could not be saved on this device.'); });
        return () => { active = false; };
    }, [layers, legend, onNotice]);
}
